import type { SiteStage } from "react-migration/domains/sites/typings/SiteStage";

export const sortMobileStagesToEnd = (a: SiteStage, b: SiteStage) => {
  return a.ref === "mobile" ? 1 : b.ref === "mobile" ? -1 : 0;
};
